// extracted by css-extract-rspack-plugin
export default {"SegmentedControlRoot":"dBIlq","Label":"e1_B5","InstanceTokenLimitInput":"vGtXg","InputDescription":"CXXOQ","QuotaMessageInputWrapper":"b1Jwz"};